import { useMemo } from 'react'
import { useProject } from '@/lib/db/rxdb/hooks/entities/projects'

export function useProjectCyclesEnabled(projectId: string | null | undefined): {
  isCyclesEnabled: boolean
  cycleDurationWeeks: number | null
  isLoading: boolean
} {
  const { project, isLoading } = useProject(projectId ?? undefined)

  const isCyclesEnabled = useMemo(() => {
    if (!projectId) return false
    if (!project) return false
    return project.isCyclesEnabled ?? false
  }, [projectId, project])

  const cycleDurationWeeks = useMemo(() => {
    if (!projectId) return null
    if (!project) return null
    return project.cycleDurationWeeks ?? null
  }, [projectId, project])

  return {
    isCyclesEnabled,
    cycleDurationWeeks,
    isLoading,
  }
}
